import { render, staticRenderFns } from "./SaveObserver.vue?vue&type=template&id=faf714ac"
import script from "./SaveObserver.vue?vue&type=script&lang=js"
export * from "./SaveObserver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports